module.exports = __webpack_public_path__ + "static/img/ls9.035a6b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls9.png
// module id = 1N3E
// module chunks = 12